import React from 'react';
import { SupportRequestModalForm } from 'features/offline-reports/support-requests/components/support-requests-modals/components/support-request-modal-form';
import { ToggleButton } from '@placer-ui/components';
import { useForm } from 'react-hook-form';
import {
    SitePlanFormValues,
    SitePlanRequestProperty,
} from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/advance-request-property/site-plan-request-property';
import {
    PolygonFormValues,
    PolygonRequestProperty,
} from 'features/offline-reports/support-requests/components/support-requests-modals/modals/request-new-location/advance-request-property/polygon-request-property';
import {
    FormControl,
    SupportRequestType,
} from 'features/offline-reports/support-requests/components/support-requests-modals/types';
import { useOpenSupportRequest } from 'features/offline-reports/support-requests/components/support-requests-modals/support-modal-manager';

const regionTypeOptions = [
    { value: 'advancedPropertyPolygon', label: 'Polygon' },
    { value: 'advancedPropertySitePlan', label: 'Site Plan' },
];

export const convertToRequestPayload = (data: PolygonFormValues | SitePlanFormValues) => {
    return {
        ...data,
        files: data.files?.map(({ file }) => file),
    };
};
export const AdvanceRequestProperty = ({ requestType }: { requestType: SupportRequestType }) => {
    const { openSupportRequest } = useOpenSupportRequest();

    const polygonFormControl = useForm<PolygonFormValues>({
        defaultValues: {
            type: 'advance_property_polygon',
        },
        mode: 'all',
    });

    const sitePlanFormControl = useForm<SitePlanFormValues>({
        defaultValues: {
            type: 'advance_property_site_plan',
        },
        mode: 'all',
    });

    const formControl =
        requestType === 'advancedPropertyPolygon' ? polygonFormControl : sitePlanFormControl;

    const onToggleButtonChange = (value: string) => {
        openSupportRequest({ flowType: value as SupportRequestType });
    };

    return (
        <SupportRequestModalForm<PolygonFormValues | SitePlanFormValues>
            title="Advanced Request"
            requestType={requestType}
            subTitle="Enter the required property details to request its addition to the platform."
            form={formControl as FormControl<PolygonFormValues | SitePlanFormValues>}
            handleBack={() => openSupportRequest({ flowType: 'property' })}
            convertToRequestPayload={convertToRequestPayload}
        >
            <ToggleButton
                testId="advance-request-property-toggle"
                size="default"
                fullWidth
                items={regionTypeOptions}
                value={requestType as string}
                onChange={onToggleButtonChange}
            />
            {requestType === 'advancedPropertyPolygon' && (
                <PolygonRequestProperty
                    formControl={formControl as FormControl<PolygonFormValues>}
                />
            )}
            {requestType === 'advancedPropertySitePlan' && (
                <SitePlanRequestProperty
                    formControl={formControl as FormControl<SitePlanFormValues>}
                />
            )}
        </SupportRequestModalForm>
    );
};
